import cardtemplate from './card.tpl.html';

export class Card {
  $onChanges(changesObj) {
    const newDisableRemove = changesObj.disableRemove && changesObj.disableRemove.currentValue;
    this.disableRemove = newDisableRemove || this.disableRemove;
  }
  close(card) {
    this.onClose({ card });
  }
}

export const card = {
  template: cardtemplate,
  controller: Card,
  bindings: {
    data: '<',
    keys: '<',
    numColumns: '<',
    type: '<',
    topClass: '<',
    onClose: '&',
    disableRemove: '<',
    canRemove: '<',
  },
};
